import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/src/app/magazine/components/MagazineInteractive.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/src/components/common/Breadcrumb.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/src/components/common/Header.tsx");
